/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_No_DescriptionInputs */

const en_course_no_description = /** @type {(inputs: Course_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description available.`)
};

const ja_course_no_description = /** @type {(inputs: Course_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明はありません。`)
};

const fr_course_no_description = /** @type {(inputs: Course_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune description disponible.`)
};

const de_course_no_description = /** @type {(inputs: Course_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beschreibung verfügbar.`)
};

/**
* | output |
* | --- |
* | "No description available." |
*
* @param {Course_No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_no_description = /** @type {((inputs?: Course_No_DescriptionInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_No_DescriptionInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_no_description(inputs)
	if (locale === "ja") return ja_course_no_description(inputs)
	if (locale === "fr") return fr_course_no_description(inputs)
	return de_course_no_description(inputs)
});